import React from "react";
import "./Home.css";

import Main from "../../components/Main/Main";
import ResultsSection from "../../components/horizontalbanner/HorizontalBanner";
import ServicesSection from "../../components/Services/Services";
import TrustedCompanies from "../../components/Companies/Companies";
import PremierPartner from "../../components/Premier/Premier";
import ImpactSection from "../../components/ImpartSec/ImpartSec";
import ContactForm from "../../components/ContactForm/ContactForm";

const Home = () => {
  return (
    <main className="home-page">

      <Main />

      <ResultsSection />

      <ServicesSection />

      <TrustedCompanies />

      <PremierPartner />

      <ImpactSection />

      <ContactForm />

    </main>
  );
};

export default Home;